import React from 'react';
import {StyleSheet, View} from 'react-native';
import {ThemeProvider} from '@rn-vui/themed';
import type {Meta, StoryObj} from '@storybook/react-native-web-vite';

import logoImg from '../../../images/brand/header-logo.png';
import rewardsTheme from '../../../theme/rewardsTheme';

import MemberCard from './index';

const meta = {
  title: 'Components/Rewards/MemberCard',
  component: MemberCard,
  argTypes: {
    cardNumber: {
      control: 'text',
    },
    name: {
      control: 'text',
    },
    pending: {
      control: 'boolean',
    },
    memberSince: {
      control: 'text',
    },
    isStaff: {
      control: 'boolean',
    },
  },
  decorators: [
    Story => (
      <ThemeProvider theme={rewardsTheme}>
        <View style={styles.container}>
          <Story />
        </View>
      </ThemeProvider>
    ),
  ],
} satisfies Meta<typeof MemberCard>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
  args: {
    logoImg,
    cardNumber: '234234',
    name: 'David Gyte',
  },
};

export const ActiveCard: Story = {
  args: {
    logoImg,
    cardNumber: '123456789',
    name: 'John Smith',
    pending: false,
  },
};

export const PendingCard: Story = {
  args: {
    logoImg,
    cardNumber: '987654321',
    name: 'Jane Doe',
    pending: true,
  },
};

export const LongName: Story = {
  args: {
    logoImg,
    cardNumber: '555666777',
    name: 'Christopher Alexander Richardson',
    pending: false,
  },
};

export const ShortCardNumber: Story = {
  args: {
    logoImg,
    cardNumber: '12345',
    name: 'Bob Wilson',
    pending: false,
  },
};

export const WithMemberSince: Story = {
  args: {
    logoImg,
    cardNumber: '234234',
    name: 'David Gyte',
    memberSince: '2021-06-15',
  },
};

// DIS-1239: brand-aligned STAFF pill for retail-staff loyalty accounts
export const StaffMember: Story = {
  args: {
    logoImg,
    cardNumber: '9300000010006118',
    name: 'David Gyte',
    memberSince: '2025-11-26',
    isStaff: true,
  },
};

export const AllVariants: Story = {
  render: () => (
    <View style={styles.variantsContainer}>
      <MemberCard logoImg={logoImg} cardNumber="234234" name="David Gyte" />
      <MemberCard
        logoImg={logoImg}
        cardNumber="234234"
        name="David Gyte"
        memberSince="2021-06-15"
      />
      <MemberCard
        logoImg={logoImg}
        cardNumber="9300000010006118"
        name="David Gyte"
        memberSince="2025-11-26"
        isStaff
      />
      <MemberCard logoImg={logoImg} cardNumber="987654321" name="Jane Doe" pending />
      <MemberCard logoImg={logoImg} cardNumber="123456789" name="John Smith" />
    </View>
  ),
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    justifyContent: 'center',
  },
  variantsContainer: {
    gap: 16,
  },
});
